import React from 'react';
import SalesRegisterTable from '../sales/components/SalesRegister';

const SalesRegister = () => {
  return <SalesRegisterTable />;
};

export default SalesRegister;

